import { SiteRFPPhaseAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { SiteRFPPhaseOption } from './getSiteRFPPhaseLabel'

type SiteRFPPhaseValues = `${SiteRFPPhaseAPIResponse}`

/** Split 'DeriskingAndPermits' into its two phase chips: 'derisking' and 'permits'. */
export function handlePhase(phase: SiteRFPPhaseValues): SiteRFPPhaseOption[] {
  if (phase === SiteRFPPhaseAPIResponse.DeriskingAndPermits) {
    return [SiteRFPPhaseAPIResponse.Derisking, SiteRFPPhaseAPIResponse.Permits]
  }
  return [phase]
}
